import React from 'react'

const EmptyCategory = () => {
    return (
        <div className="my-6 grid sm:grid-cols-1 md:grid-cols-3">
            <div className="text-center h-1/3">
                <p>No properties availabe</p>
            </div>
        </div>
    )
}

export default EmptyCategory